"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getTrainingProgression_1 = __importDefault(require("./graphql/getTrainingProgression"));
const TrainingInterface_1 = require("../../../BusinessLogicLayer/TrainingInterface");
const getTrainingProgressionForDay_1 = __importDefault(require("./graphql/getTrainingProgressionForDay"));
const getDaysType_1 = __importDefault(require("./graphql/getDaysType"));
class Training {
    constructor(client, dateTimeProvider, dateTimeModifier, cacheStrategy, adapter, dateTimeBridge, logger) {
        this.getRange = async (userId, dateRange) => {
            this.logger.log(`Training Range (${dateRange.from} - ${dateRange.to}) for ${userId}`);
            const { progressCollection, } = await this.client.fetch("getTrainingProgressionQuery", (0, getTrainingProgression_1.default)(userId, dateRange), null);
            return {
                days: this.adapter.adaptDateRange(progressCollection),
            };
        };
        this.getTrainingsPerWeek = async (userId, date) => {
            const range = this.dateTimeModifier.getWeekBoundaryFromDate(date);
            const { progressCollection, } = await this.client.fetch("getDaysTypeQuery", (0, getDaysType_1.default)(userId, range), null);
            return this.countTrainingsInDateRange(progressCollection);
        };
        this.countTrainingsInDateRange = (days) => {
            if (!days)
                return 0;
            return days.reduce((acc, { dayType }) => {
                if (dayType === "TRAINING") {
                    return acc + 1;
                }
                return acc;
            }, 0);
        };
        this.fetchDayType = async (userId, date) => {
            var _a;
            const { progressCollection, } = await this.client.fetch("getTrainingProgressionQuery", (0, getDaysType_1.default)(userId, { from: date, to: date }), null);
            return ((_a = progressCollection[0]) === null || _a === void 0 ? void 0 : _a.dayType) || null;
        };
        this.getDate = async (userId, systemDate, unit) => {
            return this.cacheStrategy.get(`TRAINING.DATE.${systemDate}.${userId}`, async () => {
                var _a, _b, _c;
                const result = await this.client.fetch("singleTrainingDay", getTrainingProgressionForDay_1.default, {
                    userId: parseInt(userId),
                    from: systemDate,
                    to: systemDate,
                });
                const firstItem = result.progressCollection[0] || null;
                return {
                    dayType: (await this.fetchDayType(userId, systemDate)) ||
                        TrainingInterface_1.WeekDayType.RECOVERY,
                    day: this.dateTimeProvider.dayOfWeek(systemDate),
                    date: this.dateTimeBridge.userDate(systemDate),
                    training: firstItem
                        ? await this.adapter.adapt(systemDate, firstItem, unit)
                        : null,
                    weekInfo: {
                        trainingOrdinalNumber: ((_a = firstItem === null || firstItem === void 0 ? void 0 : firstItem.info) === null || _a === void 0 ? void 0 : _a.trainingOrdinalNumber) || null,
                        doneTrainings: ((_b = firstItem === null || firstItem === void 0 ? void 0 : firstItem.info) === null || _b === void 0 ? void 0 : _b.doneTrainings) || 0,
                        trainings: ((_c = firstItem === null || firstItem === void 0 ? void 0 : firstItem.info) === null || _c === void 0 ? void 0 : _c.trainingsInWeek) || 0,
                    },
                };
            });
        };
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.client = client;
        this.cacheStrategy = cacheStrategy;
        this.adapter = adapter;
        this.dateTimeBridge = dateTimeBridge;
        this.logger = logger;
    }
}
exports.default = Training;
//# sourceMappingURL=Training.js.map